module.exports = __webpack_public_path__ + "static/img/IT.8ce4289b.svg";